import React from "react";
import { styled } from "styled-components";
const StyledLink = styled.a `
  background-color: white;
  color: #c31230;
  border: none;
  cursor: pointer;
  display: inline-block;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  user-select: none;
  text-align: center;

  :active,
  .active,
  &:focus,
  &:hover {
    color: #545b62;
    text-decoration: underline;
  }
  &:disabled,
  &[disabled] {
    opacity: 0.65;
    cursor: inherit;
  }
`;
export const Link = ({ to, children, ...props }) => (React.createElement(StyledLink, { href: to, ...props }, children));
export default Link;
//# sourceMappingURL=Link.js.map